import { gql } from '@apollo/client';
import { initializeApollo } from '~/shared/libs/apollo/apollo-provider';

type UploadInput = {
  fileName: string; language: string; destination: string; fileFormat: string; size: number;
};
type UploadSession = { uploadId: string; key: string; contentType: string };

const mutation = gql`
  mutation InitUploadBatch($files: [UploadBatchFileInput!]) {
    initUploadBatchMutation(files: $files) { uploadId key contentType }
  }
`;

export async function initUploadBatch(files: UploadInput[]): Promise<UploadSession[]> {
  const client = await initializeApollo();
  const result = await client.mutate<{ initUploadBatchMutation: UploadSession[] }>({
    mutation,
    variables: { files },
    context: { headers: { 'Apollo-Require-Preflight': 'true' } },
  });
  const sessions = result.data?.initUploadBatchMutation;
  if (!Array.isArray(sessions) || sessions.length !== files.length ||
      sessions.some(session => !session?.uploadId || !session?.key)) {
    throw new Error('Could not initialize the upload package');
  }
  return sessions;
}
